/**
 * name 热点关联散点图
 * author zhang.yingyu
 * createTime 2019-04-01
 */
angular.module('hotPointScatterChartModule', [])
    .directive('hotPointScatterChartDir', ['$q', '$timeout','$filter', function ($q, $timeout, $filter) {
        return {
            restrict: 'E',
            replace: true,
            template: "<div ng-style=\"myStyle\" ng-click=\"request(params)\"></div>",
            scope: {
                optionDatas: "="
            },
            link: function ($scope, iElement, iAttrs) {
                $timeout(function () {
                    $scope.myStyle = {
                        height: '105%',
                        width: '100%'
                    };
                    /**
                     * [getHotPointTime description] 获取热点时间
                     */
                    $scope.getHotPointTime=function(time){
                        if(!!time){
                            return $filter('date')(new Date(time), 'MM-dd HH:mm:ss');
                        }
                    };
                    var myChart;
                    $scope.$watch("optionDatas", function (newVal, oldVal) {
                            if (angular.isDefined($scope.optionDatas)) {
                                var scatterRangeData=[18,38];
                                var isTrue=parseInt($scope.optionDatas[0].WEIGHTEDNUMS)>parseInt($scope.optionDatas[$scope.optionDatas.length-1].WEIGHTEDNUMS);
                                var pointerData=$scope.optionDatas.map(function(item,index){
                                    var obj={
                                        TITLE:item.TITLE,
                                        KEYWORDS:item.KEYWORDS,
                                        ENTITYNAME:item.ENTITYNAME,
                                        ENTITYORG:item.ENTITYORG,
                                        WEIGHTEDNUMS:item.WEIGHTEDNUMS,
                                        ANALYTICALNUMS:item.ANALYTICALNUMS,
                                        STARTTIME:item.STARTTIME,
                                        DATE:item.DATE,
                                        ENDTIME:item.ENDTIME,
                                        ID:item.ID,
                                        CONTENT:item.CONTENT,
                                        SCATTERPOINTER:isTrue?scatterRangeData[1]--:scatterRangeData[0]++
                                    };
                                    var arr=[parseInt(item.ANALYTICALNUMS),parseInt(item.WEIGHTEDNUMS),{detail:obj}];
                                    return arr;
                                });
                                var itemStyle = {
                                    normal: {
                                        opacity: 0.8,
                                        shadowBlur: 20,
                                        shadowOffsetX: 0,
                                        shadowOffsetY: 0,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    }
                                };
                                var option = {
                                    backgroundColor: '#fff',
                                    color: '#3080FF',
                                    grid: {
                                        x: '6%',
                                        x2: '7%',
                                        y: '5%',
                                        y2: '18%'
                                    },
                                    dataZoom: [
                                        {
                                            type: 'inside'
                                        }, {
                                            show: true,
                                            type: 'slider',
                                            top: '92%'
                                        }
                                    ],
                                    tooltip: {
                                        padding: 10,
                                        backgroundColor: '#292F3A',
                                        borderColor: '#292F3A',
                                        borderWidth: 1,
                                        formatter: function (obj) {
                                            var value = obj.value[2].detail;
                                            return `<div style="padding:10px;box-sizing:border-box;color:#fff;font-size:14px; word-break: break-all"><p style="word-break: break-all;width:100%;">${value.TITLE}</p><p>${$scope.getHotPointTime(value.STARTTIME)} 至 ${$scope.getHotPointTime(value.ENDTIME)}</p></div>`;
                                        }
                                    },
                                    xAxis: {
                                        type: 'value',
                                        name: '分析价值',
                                        nameGap: 30,
                                        nameTextStyle: {
                                            color: '#3e3e3e',
                                            fontSize: 14,
                                        },
                                        nameLocation: 'center',
                                        splitLine: {
                                            show: false
                                        },
                                        axisTick: {
                                            show: false
                                        },
                                        axisLabel: {
                                            margin: 15,
                                            textStyle: {
                                                color: "#2A2A2A",
                                            }
                                        },
                                        axisLine: {
                                            lineStyle: {
                                                color: '#E2E6ED'
                                            }
                                        }
                                    },
                                    yAxis: {
                                        type: 'value',
                                        name: '热度值',
                                        nameLocation: 'end',
                                        nameGap: 5,
                                        nameTextStyle: {
                                            color: '#3e3e3e',
                                            fontSize: 16
                                        },
                                        axisLine: {
                                            lineStyle: {
                                                color: '#E2E6ED'
                                            }
                                        },
                                        axisTick: {
                                            show: false
                                        },
                                        axisLabel: {
                                            margin: 5,
                                            textStyle: {
                                                color: "#2A2A2A",
                                            }
                                        },
                                        splitLine: {
                                            show: true,
                                            lineStyle: {
                                                type: 'dashed'
                                            }
                                        }
                                    },
                                    series: [
                                        {
                                            symbolSize: function (data) {
                                                var symbolSize=data[2].detail.SCATTERPOINTER;
                                                return symbolSize;
                                            },
                                            name: '',
                                            type: 'scatter',
                                            itemStyle: itemStyle,
                                            data: pointerData
                                        }
                                    ]
                                };
                                require(['echarts'], function (echarts) {
                                    if (myChart != null && myChart != "" && myChart != undefined) {
                                        myChart.dispose();
                                    }
                                    myChart = echarts.init(iElement[0]);
                                    myChart.setOption(option);
                                    window.addEventListener("resize", function () {
                                        myChart.resize();
                                    });
                                    myChart.on("click", function (params) {
                                        var tranDatas = params.data;
                                        $scope.$emit('getScatterData', {tranDatas: tranDatas});
                                    });
                                });
                            }
                    });
                }, 300);
            }
        };
    }]);